import React, { useState, useEffect } from 'react'
import { createPortal } from "react-dom";
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import QRCode from "react-qr-code";
import ErrorAlert from '../Alerts/ErrorAlert';
import yappy from "./img/yappy.png"
import YappyStep from "./img/YappyStep.png"


function ModalYappyQrPos({ modalYappyQr, setModalYappyQr, dataYappy, setDataHash, setYappy_transaction_id, dataHash, hadleCancelYappy, total, orderNumber, totaltopay }) {
    const [show, setShow] = useState(true);
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))


    useEffect(() => {
        if (!modalYappyQr) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = prev; };
    }, [modalYappyQr]);

    if (!modalYappyQr) return null;

    return createPortal(
        <div className="yqr-overlay" role="dialog" aria-modal="true" aria-label="Pago con Yappy">
            <div className="yqr-dialog">

                {/* ---------------- HEADER ---------------- */}
                <header className="yqr-head">
                    <img className="yqr-logo" src={yappy} alt="Yappy" />

                    <div className="yqr-head-text">
                        <span className="yqr-head-label">Total a pagar</span>
                        <span className="yqr-head-amount" translate="no">${totaltopay.toFixed(2)}</span>
                    </div>

                    <span className="yqr-order">Orden {orderNumber}</span>
                </header>

                {/* ---------------- BODY ---------------- */}
                <div className="yqr-body">

                    <div className="yqr-qr-wrap">
                        <div className="yqr-qr">
                            <QRCode
                                value={dataHash}
                                size={256}
                                viewBox="0 0 256 256"
                                style={{ height: "auto", width: "100%", maxWidth: "100%" }}
                            />
                        </div>
                    </div>

                    <h2 className="yqr-title">Escanea el código con la app de Yappy</h2>
                    <p className="yqr-text">
                        Abre tu banca en línea, entra a Yappy y escanea. El cobro se confirma solo.
                    </p>

                    <img className="yqr-steps" src={YappyStep} alt="Pasos para pagar con Yappy" />

                    <p className="yqr-waiting">
                        <span className="yqr-dot" aria-hidden="true" />
                        Esperando confirmación del pago…
                    </p>

                </div>

                {/* ---------------- FOOTER ---------------- */}
                <div className="yqr-foot">
                    <button
                        type="button"
                        className="yqr-btn yqr-btn--cancel"
                        onClick={() => hadleCancelYappy()}
                    >
                        Cancelar pago
                    </button>
                </div>

            </div>
        </div>,
        document.body
    )
}

export default ModalYappyQrPos